/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantViewModel } from '../../models/merchant-view-model';
import { PostMerchantRequest } from '../../models/post-merchant-request';

export interface RegisterMerchant$Params {
      body: PostMerchantRequest
}

export function registerMerchant(http: HttpClient, rootUrl: string, params: RegisterMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantViewModel>> {
  const rb = new RequestBuilder(rootUrl, registerMerchant.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantViewModel>;
    })
  );
}

registerMerchant.PATH = '/merchants';
